import { render } from "./Disclaimer.vue?vue&type=template&id=e777842a&scoped=true"
import script from "./Disclaimer.vue?vue&type=script&lang=js"
export * from "./Disclaimer.vue?vue&type=script&lang=js"

import "./Disclaimer.vue?vue&type=style&index=0&id=e777842a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\divindenduitkering_toets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e777842a"]])

export default __exports__